import { useTranslation } from 'react-i18next'
import type { DecorationType } from 'src/services/apollo/generated/graphql'
import { useDecoration } from 'src/services/apollo/user-decoration'

export const DECORATION_TYPE_I18NKEY: Record<DecorationType, string> = {
  BADGE: 'common:user-badge.label',
  AVATAR_FRAME: 'common:user-avatar-frame.label',
  ARTWORK_FRAME: 'common:user-artwork-frame.label',
  LIVE_BANNER: 'common:user-live-banner.label',
}

/** Resolves a decoration `code` to its localized type label. Returns `null` while loading. */
export function useDecorationLabel(code: string): string | null {
  const { t } = useTranslation(['common'])
  const { data } = useDecoration({ code })
  if (!data) return null
  return t(DECORATION_TYPE_I18NKEY[data.type])
}

/**
 * Tailwind overrides that force `DecorationRenderer`'s inner `<img>` to fill (and
 * be contained by) a small fixed-size slot. AvatarFrame defaults to absolute +
 * intrinsic size, which overflows boxes smaller than the asset.
 */
export const CONTAINED_DECORATION_PREVIEW_CLASSES =
  'absolute inset-0 [&_img]:!static [&_img]:!size-full [&_img]:!translate-x-0 [&_img]:!translate-y-0 [&_img]:!scale-100 [&_img]:!object-contain'
